import React from 'react'
import LandlordMaintenace from '../Components/Maintenace/Landllord/LandlordMaintenace'

const LandlordMaintenancePage = () => {
  return (
    <LandlordMaintenace />
  )
}

export default LandlordMaintenancePage